<template>
  <generic-view :prepend="url" :steps="steps" not-numbered :loading="loading">
    <introduction
      v-show="step == 'introduction'"
      :endpoint="endpoint"
      @next-step="next"
    ></introduction>
    <template v-if="sas">
      <div v-for="s in realSteps" :key="s.path">
        <div v-show="step == s.path">
          <headline :code="s.code"></headline>
          <component :is="s.path" :sas="sas" @validation-changed="setState(s.path, $event)" :ref="s.path">
            <ressource :code="s.code" />
          </component>
          <v-btn color="#3a3838" dark class="mt-6" x-large @click="next">Enregistrer et continuer</v-btn>
        </div>
      </div>
      <soumission v-show="step == 'soumission'" :showAlert="formulaireNonValide" @submit="submitCustom" ref="soumission"></soumission>
    </template>
  </generic-view>
</template>

<script>
import { mapGetters } from "vuex"
import { Api } from "@/plugins/api"
import Introduction from "@/components/FormParts/Introduction"
import ServicesReference from "@/components/ModificationServiceReference/ServicesReference"
import FormulaireViewBase from "@/mixins/FormulaireViewBase"
import FormulaireBase from "@/mixins/FormulaireBase"
import Soumission from "@/components/FormParts/Soumission"

export default {
  mixins: [FormulaireViewBase, FormulaireBase],

  data() {
    return {
      url: "/modification-service-reference/",
      endpoint: "modification-service-reference",
      paramsName: "modification-service-achat",
      loadPanierOnLoad: false,
      steps: [
        { path: "introduction", code: "titre-introduction", state: "" },
        { path: "services-reference", code: "titre-etape-1", state: "" },
        { path: "soumission", code: "titre-soumission" },
      ],
    }
  },

  components: {
    Introduction,
    ServicesReference,
    Soumission
  },

  metaInfo() {
    return {
      title: this.$i18n.t("meta.formulaires.title"),
    }
  },
  computed: {
    ...mapGetters(["contactId"]),
  },
  methods: {
    submitCustom() {
      this.formulaireNonValide = false
      if (this.validate()) {
        this.loading = true
        
        Api.post(this.endpoint + "/submitCustom/" + this.contactId, this.sas)
          .then((res) => {
            if (res.data.traite) {
              this.$router.push({
                name: "FormulaireTraite",
              })
            } else {
              this.$router.push({
                name: "FormulaireSoumis"
              })
            }
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.formulaireNonValide = true
      }
    },
  },
}
</script>

<style></style>
